import React from 'react'
import { Spinner } from 'react-rainbow-components'
import './loading.scss'
import { CircularProgress } from '@mui/material'

const Loading: React.FC = () => (
  <div className="loading" style={{ backgroundColor: '#75757500' }}>
    <CircularProgress sx={{ fontSize: 30 }} />
  </div>
)
export default Loading
